import { LandingPageAction } from '../interfaces/LandingPageAction';

const activities1 = '/images/co-branded-images/activities1.png';
const activities2 = '/images/co-branded-images/activities2.png';
const activities3 = '/images/co-branded-images/activities3.png';
const conductingNegotiationsBoardroom = '/images/co-branded-images/conducting-negotiations-boardroom.png';
const shardaLogo = '/images/sharda/SHARDA-UNIVERSITY-logo.svg';

interface dataProps {
	headerBanner?: any;
	aboutUs?: any;
	learningPotential?: {
		heading: string;
		order: number;
		data: { text: string; data: { points: string[]; text: string; image: string; action?: LandingPageAction } }[];
	};
	highlights?: { heading: string; order: number; data: { text: any; image: string }[] };
	activities?: any;
	results?: any;
	companiesMarqueeData?: any;
	testimonial?: any;
	faq?: any;
	footerBanner?: any;
	orgBanner?: any;
	prepleafRegister?: any;
	prepleafTestBanner?: any;
	gatewayToDreamCareer?: any;
	logo: string;
	leaderboardVisibleTime?: string;
	leaderboardVisibleDate?: string;
}

export let data: dataProps = {
	logo: shardaLogo,
	orgBanner: {
		order: 1,
		logoUrl: '/images/sharda/prepleaf-sharda-logo.svg',
		associationText: `Sharda University, in association with Prepleaf:\nNurturing future-ready leaders through the powerful synergy of academia and industry`,
		professorImage: '',
		professorName: '',
		professorQuote: `“ With this endeavor, we set in motion students' journey towards excellence, unlocking a realm of boundless possibilities.”`,
		professorPost: '',
	},
	prepleafRegister: {
		order: 2,
		backgroundGrid: '/images/sharda/grid.svg',
		rightImage: '/images/sharda/rightImage.svg',
		subheading: 'Prepleaf Ace',
		heading: 'Advanced Career Evaluation',
		testDateHeader: 'Test Date',
		testDate: '19th September',
		buttonCtaText: 'Register',
	},
	gatewayToDreamCareer: {
		order: 3,
		heading: 'Your Gateway to your dream career',
		steps: [
			{
				image: 'images/sharda/step4.svg',
				text: 'Attempt Test',
			},
			{
				image: 'images/sharda/step3.svg',
				text: 'Know Where You Stand',
			},
			{
				image: 'images/sharda/step2.svg',
				text: 'Qualify for Elite ',
			},
			{
				image: 'images/sharda/step1.svg',
				text: '10LPA+ Placement',
			},
		],
	},

	// headerBanner: {
	// 	order: 1,
	// 	varient: 3,
	// 	image: headerBannerImage,
	// },
	// aboutUs: {
	// 	order: 2,
	// 	heading: 'About us',
	// 	image: aboutUsImage,
	// 	text: 'This test is designed to assess the knowledge, skills, and competencies of students in specific areas of study. It will help identify strengths and areas for improvement.',
	// },
	learningPotential: {
		heading: 'Our Offerings',
		order: 2,
		data: [
			{
				text: 'Masterclass',
				data: {
					text: 'Masterclass',
					image: activities2,
					points: [
						'Unlock your true potential with personalized mentorship and powerful learning experiences. Gain insights from industry pros through inspiring lectures and skill-building sessions. Dive into masterclasses, workshops, and bootcamps that supercharge your academic and career growth.',
					],
				},
			},
			{
				text: 'Community',
				data: {
					text: 'Community',
					image: activities3,
					points: [
						'Join our vibrant community that encourages innovation and teamwork. Dive into limitless opportunities with entrepreneurship, programming, and tech enthusiasts’ clubs. Interact with like-minded people in networking events and project expos and build meaningful friendships and bonds that’ll help you in your career.',
					],
					action: { href: 'https://prlf.link/Geqo', text: 'Join Community', action: 'link', variant: 'primary', newTab: true },
				},
			},
			{
				text: 'Career Counselling',
				data: {
					text: 'Career Counselling',
					image: conductingNegotiationsBoardroom,
					points: [
						'Experience personalized career counseling with our experts. One-stop solution connecting you with your future. We help you lay the foundations for your career, from skill development to how to find a job. You’ll understand yourself and the job market much better - getting you exponentially closer to your desired career.',
					],
					action: { action: 'book-slot', text: 'Book Now For Free', variant: 'primary' },
				},
			},
			{
				text: 'Free Resources',
				data: {
					text: 'Free Resources',
					image: activities1,
					points: [
						'Industry-Relevant Course Content designed by industry experts, covering the latest trends, technologies, and tools. Equipping learners with the most relevant and up-to-date knowledge demanded by the job market. 10,000+ hours of self-paced videos on Aptitude, Data Analytics, Web Dev, Finance, and a lot more. ',
					],
					action: { action: 'link', href: 'https://www.prepleaf.com/resources', text: 'Coming Soon', disabled: true },
				},
			},
		],
	},
	// highlights: {
	// 	heading: 'Highlights',
	// 	order: 3,
	// 	data: [
	// 		{
	// 			text: (
	// 				<>
	// 					Year of Establishment <br /> 2007
	// 				</>
	// 			),
	// 			image: hightlight1,
	// 		},
	// 		{
	// 			text: (
	// 				<>
	// 					Campus Size <br /> 50+ Acres
	// 				</>
	// 			),
	// 			image: hightlight2,
	// 		},
	// 		{
	// 			text: (
	// 				<>
	// 					Total Students <br /> 20000+
	// 				</>
	// 			),
	// 			image: hightlight3,
	// 		},
	// 		{
	// 			text: (
	// 				<>
	// 					Total Programs <br /> 100+
	// 				</>
	// 			),
	// 			image: hightlight4,
	// 		},
	// 	],
	// },
	// activities: {
	// 	order: 4,
	// 	heading: 'Activities',
	// 	data: [
	// 		{
	// 			image: activities1,
	// 			link: '/sign-in',
	// 			heading: 'Competitions',
	// 			buttonText: 'start competing',
	// 			text: (
	// 				<>
	// 					Step into the world of hackathons, coding competitions, and algorithm contests including top-tier national showdowns. Engage with peers,
	// 					tackle real-world problems, and improve your problem-solving skills. Put your coding passion into action and earn recognition and prizes.
	// 				</>
	// 			),
	// 		},
	// 		{
	// 			image: activities2,
	// 			link: '/sign-in',
	// 			heading: 'Mentorship',
	// 			buttonText: 'know more',
	// 			text: (
	// 				<>
	// 					Unlock your true potential with personalized mentorship and powerful learning experiences. Gain insights from industry pros through
	// 					inspiring lectures and skill-building sessions. Dive into masterclasses, workshops, and bootcamps that supercharge your academic and
	// 					career growth.
	// 				</>
	// 			),
	// 		},
	// 		{
	// 			image: activities3,
	// 			link: '/sign-in',
	// 			heading: 'Community',
	// 			buttonText: 'join community',
	// 			text: (
	// 				<>
	// 					Join our vibrant community that encourages innovation and teamwork. Dive into limitless opportunities with entrepreneurship, programming,
	// 					and tech enthusiasts’ clubs. Interact with like-minded people in networking events and project expos and build meaningful friendships and
	// 					bonds that’ll help you in your career.
	// 				</>
	// 			),
	// 		},
	// 	],
	// },
	companiesMarqueeData: {
		order: 2,
		title: 'Meet Our 4000+ Hiring Partners',
		companiesLogo: [
			'https://masai-website-images.s3.ap-south-1.amazonaws.com/moneytap_d5a6c9d532.svg',
			'https://masai-website-images.s3.ap-south-1.amazonaws.com/urbanpiper_2884348a0b.svg',
			'https://masai-website-images.s3.ap-south-1.amazonaws.com/airmeet_93e45faced.svg',
			'https://masai-website-images.s3.ap-south-1.amazonaws.com/paytm_a5c1ce2bc6.svg',
			'https://masai-website-images.s3.ap-south-1.amazonaws.com/whitehat_5a86f1e308.svg',
			'https://masai-website-images.s3.ap-south-1.amazonaws.com/bharatpe_a3a5a3f552.svg',
			'https://masai-website-images.s3.ap-south-1.amazonaws.com/swiggy_bc1b88842e.svg',
			'https://masai-website-images.s3.ap-south-1.amazonaws.com/salesken_baefe048ac.svg',
			'https://masai-website-images.s3.ap-south-1.amazonaws.com/vyapar_3f3770ebb5.svg',
			'https://masai-website-images.s3.ap-south-1.amazonaws.com/capgemini_31a863e94f.svg',
			'https://masai-website-images.s3.ap-south-1.amazonaws.com/simplilearn_f8af8de923.svg',
			'https://masai-website-images.s3.ap-south-1.amazonaws.com/pagarbook_2746958f65.svg',
			'https://masai-website-images.s3.ap-south-1.amazonaws.com/smallcase_1740bcc33f.svg',
			'https://masai-website-images.s3.ap-south-1.amazonaws.com/bharatagri_d4794042fe.svg',
			'https://masai-website-images.s3.ap-south-1.amazonaws.com/sharechat_23a9923a34.svg',
			'https://masai-website-images.s3.ap-south-1.amazonaws.com/leapfinance_0d785d05eb.svg',
			'https://masai-website-images.s3.ap-south-1.amazonaws.com/leapfinance_0d785d05eb.svg',
			'https://masai-website-images.s3.ap-south-1.amazonaws.com/ola_15b5ee2b82.svg',
			'https://masai-website-images.s3.ap-south-1.amazonaws.com/ibm_795b5429ee.svg',
			'https://masai-website-images.s3.ap-south-1.amazonaws.com/byjus_e7b97a9c80.svg',
			'https://masai-website-images.s3.ap-south-1.amazonaws.com/ajio_a16cd7a85b.svg',
			'https://masai-website-images.s3.ap-south-1.amazonaws.com/ajio_a16cd7a85b.svg',
			'https://masai-website-images.s3.ap-south-1.amazonaws.com/globallogic_c30eb641f7.svg',
			'https://masai-website-images.s3.ap-south-1.amazonaws.com/eatfit_9dc276a187.svg',
			'https://masai-website-images.s3.ap-south-1.amazonaws.com/dream11_d6c8d97a52.svg',
			'https://masai-website-images.s3.ap-south-1.amazonaws.com/homelane_e9cadd0c3c.svg',
		],
	},
	results: {
		order: 5,
		topHeading: 'Powerful Results',
		centerHeading: 'Real Returns in Real Time',
		bottomHeading: '3000 students placed across 1000+ companies.',
		data: [
			{
				heading: '4,000+',
				text: 'Hiring Partners',
			},
			{
				heading: '6.9 LPA',
				text: 'Average CTC',
			},
			{
				heading: '6,000+',
				text: 'Currently Enrolled Students',
			},
			{
				heading: '91%',
				text: 'Placement Rate',
			},
		],
	},
	// testimonial: {
	// 	order: 6,
	// 	image: testimonial,
	// 	name: 'Abhijeet Singh',
	// 	designation: 'Principal, Sage University',
	// 	text: '“One of the best parts of being at Masai is the impact you can produce on the lives of thousands of students and their families. All of this is only possible when an organisation collectively loves what it does.”'
	// },

	faq: {
		order: 8,
		title: 'Frequently Asked Questions',
		faqs: [
			{
				question: 'Is this ACE test free for students?',
				answer: "Certainly, the ACE test is completely free for students. You won't need to pay any fees to participate in the test.",
				questionType: 'co-branded',
			},
			{
				question: 'What benefits can I expect from participating in the test?',
				answer:
					'By participating in the test, you open the door to various opportunities and benefits, including an Elite Opportunity. It provides intensive, free training over 2 months to enhance your skills and prepare you for the professional world.',
				questionType: 'co-branded',
			},
			{
				question: 'What is the potential job package after Elite',
				answer:
					'Upon achieving Elite status, you stand a chance to unlock your dream job with access to a network of over 4000+ hiring partners associated with Prepleaf. This network provides you with a wide range of job opportunities, many of which offer packages exceeding 10 LPA, ensuring a substantial growth trajectory for your career',
				questionType: 'co-branded',
			},
			{
				question: 'What are Waitlist Privileges?',
				answer: `Waitlist Privileges grant you recognition of your potential. You'll remain on the waitlist for the "Prepleaf Elite" and receive updates. Depending on availability and performance metrics, you may have the opportunity to join the Elite group.`,
				questionType: 'co-branded',
			},
			{
				question: 'What are the different segments in which I will be evaluated during the test?',
				answer: `The test consists of three sections: Aptitude & Reasoning, Coding, and Logical Reasoning. Carrying 20 marks each`,
				questionType: 'co-branded',
			},
		],
	},
	footerBanner: {
		order: 9,
		varient: 1,
		link: '/sign-in',
		btnText: 'start learning',
		title: 'Discover the perfect career with us!',
		text: 'At Career Guide, our mission is to provide students with the tools and resources they need for successful career decisions. We offer free online assessments and guidance to help you find the right job.',
	},
};
